import { makeRequest } from 'utils/requestLogger';

export default (course_id,payload) =>
    makeRequest('post', `/api/courses/${course_id}/messages`,payload);



// WEBPACK FOOTER //
// ./src/app/services/courses/sendChatMessage.js